import React from "react";
import PropTypes from "prop-types";
import AvatarUtils from "utils/AvatarUtils";
import noPicture from "components/Tables/no-picture.svg";
import lockIcon from "assets/images/lockimage.svg";

function AvatarComponent({ firstname, lastname, userType, avatar, locked }) {
  if (avatar !== null) {
    return (
      <div>
        <div className="b-org-img-wrap">
          <img
            className={`b-organization-listing__img ${
              !avatar ? "no-picture" : ""
            }`}
            src={avatar}
            alt=""
            onError={({ currentTarget }) => {
              // eslint-disable-next-line
              currentTarget.onerror = null; // prevents looping
              // eslint-disable-next-line
              currentTarget.src = noPicture;
            }}
          />
          {locked && (
            <div className="b-org-img-wrap-overlay">
              <img src={lockIcon} alt="noImage" />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="b-org-img-wrap">
      <div
        className={`b-letter-avatar ${
          userType === "TEAM_MEMBER" ? "b-investigator" : ""
        }`}
      >
        {AvatarUtils.generateAvatarInitials(firstname, lastname)}
      </div>
      {locked && (
        <div className="b-org-img-wrap-overlay">
          <img src={lockIcon} alt="noImage" />
        </div>
      )}
    </div>
  );
}
AvatarComponent.propTypes = {
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  userType: PropTypes.string,
  avatar: PropTypes.string,
  locked: PropTypes.bool,
};

AvatarComponent.defaultProps = {
  firstname: null,
  lastname: null,
  userType: null,
  avatar: null,
  locked: false,
};

export default AvatarComponent;
